import { IOmniaCommand, IOmniaShell, LocaleString } from "../omnia"
import { IFieldsService } from "../types"

export class DisableCmd implements IOmniaCommand {

    text: LocaleString = "Disable/enable fields"
    icon: string = "disable"

    foreground = false

    constructor(public fieldSvc: IFieldsService, public shell: IOmniaShell) {

    }

    canExecute(): boolean {
        return !this.shell.isReadOnly(p => p.fields)
    }

    execute() {

        this.shell.showComponentAsDialog("omnia-fields-disable-dialog", null, {
            size: "xxlarge"
        })

    }


}
